import React, { useState } from 'react'
import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
import { NumberFormatBase } from 'react-number-format';
import { formatLocalDate } from '../../../../dateTimeFormat';
const Index = ({ state, onChange, onSubmit, addRow, isFinalSubmitting, setIsFinalSubmitting, history, hullOptions, summary, handleSummaryChange, weekEndingSunday }) => {
    const getWeekDates = (weekEndingSunday) => {
        const endDate = new Date(weekEndingSunday);
        const dates = [];

        for (let i = 6; i >= 0; i--) {
            const d = new Date(endDate);
            d.setDate(endDate.getDate() - i);
            dates.push(formatLocalDate(d, 'en-GB', {
                day: '2-digit',
                month: 'short',
            }));
        }

        return dates;
    };

    // Example usage
    const weekDates = getWeekDates(weekEndingSunday); // Replace with your actual value


    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table
                        className="assessment-table inspn-assessment-table"
                        cellSpacing={0}
                    >
                        <tbody>

                            <tr className="bghed">
                                <td className="hd-s2" rowSpan={2}>
                                    {" "}
                                    <p>HULL No</p>
                                </td>
                                <td className="hd-s1 w200" rowSpan={2}>
                                    <p>ACTIVITY DESCRIPTION</p>
                                </td>
                                <td className="hd-s2 w200" rowSpan={2}>
                                    <p>FURTHER DETAILS IF ANY</p>
                                </td>
                                <td className="hd-s2">
                                    <p>DAY</p>
                                </td>
                                <td className="hd-s2">
                                    <p>1</p>
                                </td>
                                <td className="hd-s2">
                                    <p>2</p>
                                </td>
                                <td className="hd-s2">
                                    <p>3</p>
                                </td>
                                <td className="hd-s2">
                                    <p>4</p>
                                </td>
                                <td className="hd-s2">
                                    <p>5</p>
                                </td>
                                <td className="hd-s2">
                                    <p>6</p>
                                </td>
                                <td className="hd-s2">
                                    <p>7</p>
                                </td>
                                <td className="hd-s2" rowSpan={2}>
                                    <p>TOTAL HOURS</p>
                                </td>
                            </tr>
                            <tr className="bghed">
                                <td className="hd-s2">
                                    <p>DATE</p>
                                </td>
                                {weekDates.map((date, idx) => (
                                    <td className="hd-s2" key={idx}>
                                        <p>{date}</p>
                                    </td>
                                ))}
                            </tr>
                            {state?.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="tb-input-value">
                                            <select
                                                className="form-control"
                                                name={item.hull.name}
                                                value={item.hull.value}
                                                onChange={(e) => { onChange(item.hull.name, e.target.value, index) }}
                                            >
                                                <option value={''}>Select Hull</option>
                                                {hullOptions.map((item) => {
                                                    return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                })}
                                            </select>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter here..."
                                                name={item.activity_description.name}
                                                value={item.activity_description.value}
                                                onChange={(e) => { onChange(item.activity_description.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter here..."
                                                name={item.extra_details.name}
                                                value={item.extra_details.value}
                                                onChange={(e) => { onChange(item.extra_details.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                disabled
                                                defaultValue=""
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 0 && floatValue <= 24);
                                                }}
                                                className="form-control"
                                                placeholder='Enter Hours'
                                                name={item.day1.name}
                                                value={item.day1.value}
                                                onChange={(e) => { onChange(item.day1.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 0 && floatValue <= 24);
                                                }}
                                                className="form-control"
                                                placeholder='Enter Hours'
                                                name={item.day2.name}
                                                value={item.day2.value}
                                                onChange={(e) => { onChange(item.day2.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 0 && floatValue <= 24);
                                                }}
                                                className="form-control"
                                                placeholder='Enter Hours'
                                                name={item.day3.name}
                                                value={item.day3.value}
                                                onChange={(e) => { onChange(item.day3.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 0 && floatValue <= 24);
                                                }}
                                                className="form-control"
                                                placeholder='Enter Hours'
                                                name={item.day4.name}
                                                value={item.day4.value}
                                                onChange={(e) => { onChange(item.day4.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 0 && floatValue <= 24);
                                                }}
                                                className="form-control"
                                                placeholder='Enter Hours'
                                                name={item.day5.name}
                                                value={item.day5.value}
                                                onChange={(e) => { onChange(item.day5.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 0 && floatValue <= 24);
                                                }}
                                                className="form-control"
                                                placeholder='Enter Hours'
                                                name={item.day6.name}
                                                value={item.day6.value}
                                                onChange={(e) => { onChange(item.day6.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 0 && floatValue <= 24);
                                                }}
                                                className="form-control"
                                                placeholder='Enter Hours'
                                                name={item.day7.name}
                                                value={item.day7.value}
                                                onChange={(e) => { onChange(item.day7.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Total Hours"
                                                value={item.totalHullHours.value}
                                            />
                                        </td>
                                    </tr>
                                )
                            })
                            }

                            <tr>
                                <td className="hd-s2" colSpan={4}>
                                    <p className="text-right pr15">TOTAL WORKED HOURS</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.totalHourWorkedinDay1.name}
                                        value={summary.totalHourWorkedinDay1.value}
                                    // onChange={(e)=>handleSummaryChange(e)}

                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.totalHourWorkedinDay2.name}
                                        value={summary.totalHourWorkedinDay2.value}
                                    // onChange={(e)=>handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.totalHourWorkedinDay3.name}
                                        value={summary.totalHourWorkedinDay3.value}
                                    // onChange={(e)=>handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.totalHourWorkedinDay4.name}
                                        value={summary.totalHourWorkedinDay4.value}
                                    // onChange={(e)=>handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.totalHourWorkedinDay5.name}
                                        value={summary.totalHourWorkedinDay5.value}
                                    // onChange={(e)=>handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.totalHourWorkedinDay6.name}
                                        value={summary.totalHourWorkedinDay6.value}
                                    // onChange={(e)=>handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.totalHourWorkedinDay7.name}
                                        value={summary.totalHourWorkedinDay7.value}
                                    // onChange={(e)=>handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.grandTotalWorkingHour.name}
                                        value={summary.grandTotalWorkingHour.value}
                                    // onChange={(e)=>handleSummaryChange(e)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="hd-s2" colSpan={4}>
                                    <p className="text-right pr15">ANNUAL LEAVE</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.annualLeaveInDay1.name}
                                        value={summary.annualLeaveInDay1.value}
                                        onChange={(e) => handleSummaryChange(e)}

                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.annualLeaveInDay2.name}
                                        value={summary.annualLeaveInDay2.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.annualLeaveInDay3.name}
                                        value={summary.annualLeaveInDay3.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.annualLeaveInDay4.name}
                                        value={summary.annualLeaveInDay4.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.annualLeaveInDay5.name}
                                        value={summary.annualLeaveInDay5.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.annualLeaveInDay6.name}
                                        value={summary.annualLeaveInDay6.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.annualLeaveInDay7.name}
                                        value={summary.annualLeaveInDay7.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.grandTotalAnnualLeave.name}
                                        value={summary.grandTotalAnnualLeave.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="hd-s2" colSpan={4}>
                                    <p className="text-right pr15">HOLIDAY</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.holidayInDay1.name}
                                        value={summary.holidayInDay1.value}
                                        onChange={(e) => handleSummaryChange(e)}

                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.holidayInDay2.name}
                                        value={summary.holidayInDay2.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.holidayInDay3.name}
                                        value={summary.holidayInDay3.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.holidayInDay4.name}
                                        value={summary.holidayInDay4.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.holidayInDay5.name}
                                        value={summary.holidayInDay5.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.holidayInDay6.name}
                                        value={summary.holidayInDay6.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.holidayInDay7.name}
                                        value={summary.holidayInDay7.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.grandTotalHoliday.name}
                                        value={summary.grandTotalHoliday.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="hd-s2" colSpan={4}>
                                    <p className="text-right pr15">SICK LEAVE</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.sickLeaveInDay1.name}
                                        value={summary.sickLeaveInDay1.value}
                                        onChange={(e) => handleSummaryChange(e)}

                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.sickLeaveInDay2.name}
                                        value={summary.sickLeaveInDay2.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.sickLeaveInDay3.name}
                                        value={summary.sickLeaveInDay3.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.sickLeaveInDay4.name}
                                        value={summary.sickLeaveInDay4.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.sickLeaveInDay5.name}
                                        value={summary.sickLeaveInDay5.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.sickLeaveInDay6.name}
                                        value={summary.sickLeaveInDay6.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.sickLeaveInDay7.name}
                                        value={summary.sickLeaveInDay7.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.grandTotalSickLeave.name}
                                        value={summary.grandTotalSickLeave.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="hd-s2" colSpan={4}>
                                    <p className="text-right pr15">AUTHORISED UNPAID LEAVE</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.authorisedUnpaidLeaveInDay1.name}
                                        value={summary.authorisedUnpaidLeaveInDay1.value}
                                        onChange={(e) => handleSummaryChange(e)}

                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.authorisedUnpaidLeaveInDay2.name}
                                        value={summary.authorisedUnpaidLeaveInDay2.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.authorisedUnpaidLeaveInDay3.name}
                                        value={summary.authorisedUnpaidLeaveInDay3.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.authorisedUnpaidLeaveInDay4.name}
                                        value={summary.authorisedUnpaidLeaveInDay4.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.authorisedUnpaidLeaveInDay5.name}
                                        value={summary.authorisedUnpaidLeaveInDay5.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.authorisedUnpaidLeaveInDay6.name}
                                        value={summary.authorisedUnpaidLeaveInDay6.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.authorisedUnpaidLeaveInDay7.name}
                                        value={summary.authorisedUnpaidLeaveInDay7.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name={summary.grandTotalAuthorisedUnpaidLeave.name}
                                        value={summary.grandTotalAuthorisedUnpaidLeave.value}
                                        onChange={(e) => handleSummaryChange(e)}
                                    />
                                </td>
                            </tr>
                            <tr className="addmoreitem">
                                <td className="td-s1" colSpan={15}>
                                    <button type="button" className="btn btn-link" onClick={() => { addRow() }}>
                                        + Add New Block
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="final-checkbox">
                        <div class="form-check">
                            <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                            <label class="form-check-label" for="productdiscountCheck1">Send to Office for Review</label>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.production.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)
